import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';

import { TimelineBannerStatus } from '@models/milestone-category/milestone/timeline.service';

import { IconComponent } from '@shared/components/icon/icon.component';
import { LocalStorageKey } from '@shared/constants/localStorageKey';
import { ROUTING_PATH } from '@shared/constants/routingPath';
import { MainQuery } from '@shared/store/main/main.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgStyle, NgClass],
  selector: 'aux-timeline-warning-banner',
  styles: ``,
  templateUrl: './timeline-warning-banner.component.html',
})
export class TimelineWarningBannerComponent implements OnChanges {
  router = inject(Router);

  private mainQuery = inject(MainQuery);

  fp = '';
  sp = '';
  @Input() timelineBannerStatus: TimelineBannerStatus = undefined;

  ngOnChanges(): void {
    if (this.timelineBannerStatus) {
      this.fp =
        this.timelineBannerStatus === 'warning'
          ? 'Your trial is near the end of the timeline. Please'
          : 'You reached the end of the trial timeline. Please';
      this.sp =
        this.timelineBannerStatus === 'warning'
          ? 'if needed.'
          : 'if trial is still in progress and/or you need to take actions for future months.';
    }
  }

  hideBanner() {
    this.mainQuery.setBannerWarningVisibility(false, LocalStorageKey.TIMELINE_BANNER);
  }

  navigateToTimeline() {
    void this.router.navigateByUrl(
      `${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.TIMELINE}`
    );
  }
}
